<template>
  <b-modal
    ref="reviewModal"
    :title="$t('diagnosis.btns.review')"
    centered
    modal-class="review-modal"
    @hidden="onHidden()"
  >
    <sample-review
      v-if="ENTITY_TYPE_SAMPLE === entityType"
      ref="sampleReviewSection"
      :sample-grossing-responsible="sampleGrossingResponsible"
      :logged-laboratory-id="loggedLaboratoryId"
      :entity-current-laboratory-id="entitySelectedCurrentLaboratoryId"
      :case-id="caseId"
      :sample-id="sampleId"
      :entity-selected="entitySelected"
    />
    <portion-review
      v-else-if="ENTITY_TYPE_PORTION === entityType"
      ref="portionReviewSection"
      :sample-grossing-responsible="sampleGrossingResponsible"
      :logged-laboratory-id="loggedLaboratoryId"
      :entity-current-laboratory-id="entitySelectedCurrentLaboratoryId"
      :case-id="caseId"
      :sample-id="sampleId"
      :entity-selected="entitySelected"
    />
    <subportion-review
      v-else-if="ENTITY_TYPE_SUBPORTION === entityType"
      ref="subportionReviewSection"
      :sample-grossing-responsible="sampleGrossingResponsible"
      :entity-current-laboratory-id="entitySelectedCurrentLaboratoryId"
      :case-id="caseId"
      :sample-id="sampleId"
      :entity-selected="entitySelected"
    />
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            qa="apply-review-request"
            class="btn--primary btn-sm"
            :params="{ promise: createRevision }"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { REVISION_ENTITY_TYPE } from '@/modules/diagnosisModule/constants/revisionEntityType'
import SampleReview from '@/modules/diagnosisModule/views/form/modals/reviewModal/SampleReview'
import PortionReview from '@/modules/diagnosisModule/views/form/modals/reviewModal/PortionReview'
import SubportionReview from '@/modules/diagnosisModule/views/form/modals/reviewModal/SubportionReview'

export default {
    name: 'ReviewModal',
    components: {
        SampleReview,
        PortionReview,
        SubportionReview
    },
    props: {
        loggedLaboratoryId: { type: Number, required: true },
        caseId: { type: Number, required: true },
        sampleId: { type: Number, required: true },
        sampleGrossingResponsible: { type: Object }
    },
    data() {
        return {
            entitySelected: {},
            entityType: null
        }
    },
    computed: {
        entitySelectedCurrentLaboratoryId() {
            return this.entitySelected.currentLaboratory?.labId
        },
        ENTITY_TYPE_SAMPLE() {
            return REVISION_ENTITY_TYPE.SAMPLE
        },
        ENTITY_TYPE_PORTION() {
            return REVISION_ENTITY_TYPE.PORTION
        },
        ENTITY_TYPE_SUBPORTION() {
            return REVISION_ENTITY_TYPE.SUBPORTION
        }
    },
    methods: {
        async show(entitySelected, entityType) {
            this.entitySelected = entitySelected
            this.entityType = entityType
            this.$refs.reviewModal.show()
        },
        hide() {
            this.$refs.reviewModal.hide()
        },
        onHidden() {
            this.cleanFormData(this.entityType)
            this.$_cleanComponentData()
        },
        cleanFormData(entityType) {
            switch (entityType) {
            case this.ENTITY_TYPE_SAMPLE:
                this.$refs.sampleReviewSection?.cleanData()
                break
            case this.ENTITY_TYPE_PORTION:
                this.$refs.portionReviewSection?.cleanData()
                break
            case this.ENTITY_TYPE_SUBPORTION:
                this.$refs.subportionReviewSection?.cleanData()
                break
            }
        },
        async createRevision() {
            let call = null
            switch (this.entityType) {
            case this.ENTITY_TYPE_SAMPLE:
                call = this.$refs.sampleReviewSection.createRevisionCall.createSampleRevision(
                    this.loggedLaboratoryId,
                    this.caseId,
                    this.sampleId,
                    this.$refs.sampleReviewSection.request)
                break
            case this.ENTITY_TYPE_PORTION:
                call = this.$refs.portionReviewSection.createRevisionCall.createPortionRevision(
                    this.loggedLaboratoryId,
                    this.caseId,
                    this.sampleId,
                    this.entitySelected.id,
                    this.$refs.portionReviewSection.request)
                break
            case this.ENTITY_TYPE_SUBPORTION:
                call = this.$refs.subportionReviewSection.createRevisionCall.createSubportionRevision(
                    this.loggedLaboratoryId,
                    this.caseId,
                    this.sampleId,
                    this.entitySelected.portionId,
                    this.entitySelected.id,
                    this.$refs.subportionReviewSection.request)
                break
            }
            if (call) {
                const [error] = await this.toCall(call)
                if (error) {
                    this.showErrorModalGlobalFromErrorResponse(error)
                    return
                }
                this.showSuccessModalGlobal()
                this.$emit('revisionCreated', this.entityType)
                this.hide()
            }
        }
    }
}
</script>

<style lang="scss">
.review-modal .form-area {
    border-right: 1px solid vt-color(general-border);
}
.review-modal .form-area .title {
    color: vt-color(primary);
    font-size: font-size(very-normal);
}
.review-modal .modal-body {
    padding: 0;
}
.review-modal .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
    cursor: pointer;
}

.review-modal .switch::after {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}

.review-modal input[type="checkbox"]:checked + .switch::after {
    transform: translateX(20px);
}

.review-modal input[type="checkbox"]:checked + .switch {
    background-color: vt-color(primary);
}
.review-modal .offscreen {
    position: absolute;
    left: -9999px;
}
.review-modal .thumb-col {
    max-width: 100%;
}
.review-modal .thumbs-area .scroll-area {
    height: calc(100vh - 550px);
    overflow-y: auto;
}
.review-modal .thumbs-area .description {
    margin: 10px;
    font-size: font-size(very-small);
    line-height: 15px;
}
.review-modal .modal-dialog {
    max-width: 45% !important;
}
@media (max-width: 1300px) {
    .review-modal .modal-dialog {
        max-width: 55% !important;
    }
}
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
    .review-modal .modal-dialog {
        max-width: 55% !important;
    }
    .review-modal .thumbs-area .scroll-area {
        height: calc(100vh - 300px);
    }
}
</style>
